import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ca-internal-server-error',
  templateUrl: './internal-server-error-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternalServerErrorPageComponent {}
